import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import { modalActions, accountActions } from '../../../redux/root-action';
import { modals, accountModalViews } from '../../../utils/constants';
import { keyDown } from '../../../utils/helpers';

const StyledCard = styled.div`
  display: flex;
  @media (min-width: 768px) {
    flex: 1;
    flex-direction: column;
  }
  border-radius: 4px;
  border: solid 1px ${tokens.ColorWhite200};
  background-color: ${tokens.ColorWhite000};
  padding: 24px;
  cursor: pointer;
  margin: 8px 0px 8px 0px;
  :hover {
    border: solid 1px ${tokens.ColorBrandInteractiveBlue};
    box-shadow: 0 4px 4px 0 rgba(45, 57, 64, 0.08), 0 0 2px 0 rgba(45, 57, 64, 0.12);
  }
  @media only screen and (max-width: 767px) {
    align-items: flex-start;
  }
`;

const StyledHeaderText = styled.div`
  font-family: Nimbus Sans Light;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};
  padding-top: 32px;
  padding-bottom: 8px;
`;

const StyledImage = styled.img`
  min-height: 40px;
  max-width: 40px;
  @media (min-width: 768px) {
    width: min-content;
    margin-bottom: 24px;
  }
`;

const StyledTextContainer = styled.div`
  @media (max-width: 767px) {
    margin-left: 24px;
  }
`;

const StyledText = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 20px;
  color: ${tokens.ColorBrandInteractiveBlue};
  padding-bottom: 4px;
  @media only screen and (max-width: 767px) {
    font-size: 16px;
  }
`;

const StyledContainer = styled.div`
  padding: 16px 0px 8px 0px;
  @media (min-width: 768px) {
    display: flex;
    width: 100%;
    gap: 24px;
  }
`;

const card: Record<string, any> = {
  add: {
    title: 'Two Ways To Securely Add Accounts',
  },
  update: {
    title: 'Two Ways To Securely Update Accounts',
  },
};

class SecurelyAddAccounts extends Component<any, any> {
  addAccountModal = () => {
    const { showModal, setCurrentView } = this.props;
    showModal(modals.ACCOUNT);
    setCurrentView(accountModalViews.ADD_ACCOUNT);
  };

  render(): JSX.Element {
    const mq = window.matchMedia('(min-width: 768px)');
    const cardType = 'add';
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={card[cardType].title} showClose={true} />
        <ReactModalContent>
          {mq.matches && (
            <StyledHeaderText>
              Once you add an account, it will be included in your retirement savings balances and projections
              throughout the site. Please review your information regularly to make sure it’s up to date.
            </StyledHeaderText>
          )}
          <StyledContainer>
            <StyledCard>
              <StyledImage src={`data:image/svg+xml;base64,${tokens.AssetIconLinkAccount}`} alt="quick link icon" />
              <StyledTextContainer tabIndex={0}>
                <StyledText>Quick Link</StyledText>
                <div>We will update your account information periodically.</div>
              </StyledTextContainer>
            </StyledCard>
            <StyledCard
              tabIndex={0}
              onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.addAccountModal)}
              onClick={this.addAccountModal}
            >
              <StyledImage src={`data:image/svg+xml;base64,${tokens.AssetIconForm}`} alt="manually enter icon" />
              <StyledTextContainer tabIndex={0}>
                <StyledText>Manually Enter</StyledText>
                <div>You will need to manually update your account information.</div>
              </StyledTextContainer>
            </StyledCard>
          </StyledContainer>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  accountFields: state.addAccount,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  showModal: modalActions.showModal,
  setCurrentView: accountActions.setCurrentView,
})(SecurelyAddAccounts);
